<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <transition name="sidebarLogoFade">
      <div v-if="collapse" key="collapse" class="sidebar-logo-link rx-cc">
        <template v-if="shellConst.iconPhoto">
          <img
            v-if="shellConst.iconPhoto !== 'https://common.leqinkeji.com/kanbujian.ico'"
            :src="shellConst.iconPhoto"
            style="height: 40px"
          />
        </template>
        <template v-else>
          <img
            v-if="shellConst.websiteLogo !== 'https://common.leqinkeji.com/kanbujian.ico'"
            :src="shellConst.websiteLogo"
            style="height: 40px"
          />
        </template>
      </div>
      <div v-else key="expand" class="sidebar-logo-link rx-cc">
        <template v-if="shellConst.platfromCode === 'bxzn'">
          <img
            src="https://qiying-web-static.oss-cn-hangzhou.aliyuncs.com/assets/bxznlogo.png"
            class="h60"
            style="vertical-align: middle"
          />
        </template>
        <template v-else-if="shellConst.systemPhoto">
          <img
            v-if="shellConst.systemPhoto !== 'https://common.leqinkeji.com/kanbujian.ico'"
            :src="shellConst.systemPhoto"
            style="vertical-align: middle; height: 55px"
          />
        </template>
        <template v-else-if="shellConst.iconPhoto">
          <img
            v-if="shellConst.iconPhoto !== 'https://common.leqinkeji.com/kanbujian.ico'"
            :src="shellConst.iconPhoto"
            style="vertical-align: middle; height: 55px"
          />
          <h1 class="sidebar-title">{{ shellConst.websiteName }}</h1>
        </template>
        <template v-else>
          <img
            v-if="shellConst.websiteLogo !== 'https://common.leqinkeji.com/kanbujian.ico'"
            :src="shellConst.websiteLogo"
            style="vertical-align: middle; height: 55px"
          />
          <h1 class="sidebar-title">{{ shellConst.websiteName }}</h1>
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "SidebarLogo",
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    shellConst() {
      return this.$store.state.domain.shellConst;
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 60px;
  margin: 5px 0;
  // height: 74px;
  // line-height: 74px;
  // height: 50px;
  // line-height: 50px;
  background-color: #fff;
  // background: #2b2f3a;
  text-align: center;
  overflow: hidden;
  // border-bottom: 1px solid #ebeef5;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;
    gap: 5px;

    & .sidebar-logo {
      width: 32px;
      height: 32px;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #0069ff;
      font-weight: 600;
      // line-height: 50px;
      font-size: 14px;
      font-family:
        Avenir,
        Helvetica Neue,
        Arial,
        Helvetica,
        sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
